module.exports = __webpack_public_path__ + "media/images/apple_health/watch/stride-65e3e9c75a4ea92951c93aa603fd5ca9.svg";